import { render, staticRenderFns } from "./shareChangeDialog.vue?vue&type=template&id=c009a43a&scoped=true"
import script from "./shareChangeDialog.vue?vue&type=script&lang=js"
export * from "./shareChangeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c009a43a",
  null
  
)

export default component.exports